import * as ActionTypes from './ActionTypes';
import InitialState from './InitialState';

export default function logsReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.LIST_LOGS_SUCCESS:
            return action.result;
        default:
            return state;
    }
}
